import {
  RECOMMENDED_UNIVERSITY_FAILED,
  RECOMMENDED_UNIVERSITY_LIST_FAILED,
  RECOMMENDED_UNIVERSITY_LIST_REQ,
  RECOMMENDED_UNIVERSITY_LIST_SUCCESS,
  RECOMMENDED_UNIVERSITY_REQ,
  RECOMMENDED_UNIVERSITY_RESET,
  RECOMMENDED_UNIVERSITY_SUCCESS,
} from "../constants/eventConstants";

export const UniversityListRecReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case RECOMMENDED_UNIVERSITY_LIST_REQ: {
      return { loading: true };
    }

    case RECOMMENDED_UNIVERSITY_LIST_SUCCESS: {
      return { loading: false, recommendRec: payload };
    }

    case RECOMMENDED_UNIVERSITY_LIST_FAILED: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};

export const UniversityListUpdateReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case RECOMMENDED_UNIVERSITY_REQ: {
      return { loading: true };
    }

    case RECOMMENDED_UNIVERSITY_SUCCESS: {
      return { loading: false, success: payload };
    }

    case RECOMMENDED_UNIVERSITY_FAILED: {
      return { loading: false, error: payload };
    }

    case RECOMMENDED_UNIVERSITY_RESET: {
      return { loading: false };
    }
    default:
      return state;
  }
};
